export const contexts: CampaignContext[] = [
  'home',
  'category',
  'search',
  'product_page',
  'brand_page'
]
